<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-chip class="my-1 mx-2 item" v-bind="attrs" v-on="on">{{content}}</v-chip>
      </template>
      <span>{{title}}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="stylus" scoped>
.item
  min-width 60px
  text-align center
  height 17px !important
  font-size 10px !important
  font-weight bold
  border-bottom 1px solid #c4c4c4
  display inline-block
</style>
